import { ExtPropertiesItemsModel } from './ext-properties.items.model';
export class ExtProperties {
    items: ExtPropertiesItemsModel[];
    constructor() {
    }
}
